import { render, staticRenderFns } from "./Reglamento.vue?vue&type=template&id=5d2a0036&scoped=true"
import script from "./Reglamento.vue?vue&type=script&lang=js"
export * from "./Reglamento.vue?vue&type=script&lang=js"
import style0 from "./Reglamento.vue?vue&type=style&index=0&id=5d2a0036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2a0036",
  null
  
)

export default component.exports